<template>
  <v-sheet color="grey-darken-4" theme="dark">
    <v-container>
      <v-row>
        <v-col>
          <v-card tile variant="outlined">
            <v-card-title>
              Our Direct Repair Program (DRP) network
            </v-card-title>

            <v-row class="align-center justify-space-around flex-md-nowrap">
              <LogoLink
                :image="logoAaaWhite"
                alt="AAA"
                href="https://www.aaa.com/"
                scale="60%"
              />
              <LogoLink
                :image="logoKemperWhite"
                alt="Kemper"
                href="https://www.kemper.com/"
                scale="90%"
              />
              <LogoLink
                :image="logoLibertyMutualWhite"
                alt="Liberty Mutual Insurance"
                href="https://www.libertymutual.com/"
                scale="90%"
              />
              <LogoLink
                :image="logoMapfreWhite"
                alt="Mapfre Insurance"
                href="https://www.mapfreinsurance.com/"
                scale="100%"
              />
              <LogoLink
                :image="logoSafecoWhite"
                alt="Safeco Insurance"
                href="https://www.safeco.com/claims/auto-claims/guaranteed-repair-network"
                scale="60%"
              />
              <LogoLink
                :image="logoStateFarmWhite"
                alt="State Farm Insurance"
                href="https://www.statefarm.com/"
                scale="70%"
              />
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script setup lang="ts">
import logoAaaWhite from '#root/assets/logos/logo-aaa-white.png'
import logoKemperWhite from '#root/assets/logos/logo-kemper-white.png'
import logoLibertyMutualWhite from '#root/assets/logos/logo-liberty-mutual-white.png'
import logoMapfreWhite from '#root/assets/logos/logo-mapfre-white.png'
import logoSafecoWhite from '#root/assets/logos/logo-safeco-white.png'
import logoStateFarmWhite from '#root/assets/logos/logo-state-farm-white.png'
</script>
